export class LoadStreamerFollowing {
  static readonly type = "[StreamerFollow] Load Streamer Following";
  constructor(
    public page?: number,
    public pageSize?: number,
  ) {}
}

export class ReloadStreamerFollowing {
  static readonly type = "[StreamerFollow] Reload Streamer Following";
  constructor() {}
}

export class ClearStreamerFollowing {
  static readonly type = "[StreamerFollow] Clear Streamer Following";
  constructor() {}
}
